// 이미지 렌더링 해주는 함수로 임시로 맏들어 놓았습니다
export function makeNewImagePath(id) {
  return `https://dummyimage.com/600x400/eee/fd8a69.png&text=${id}`;
}

export function makePopularImagePath(id) {
  return `https://dummyimage.com/600x400/555/fff.png&text=${id}`;
}
